import { planningResourcesMobilityManagementComponent } from './planning-resources-mobility-management.component';
import { MobilityManagementMapService } from './planning-resources-mobility-management.service';
import './planning-resources-mobility-management.scss'

export const planningResourcesMobilityManagement = angular
     .module('components.planningResourcesMobilityManagement', [])
     .component('planningResourcesMobilityManagement', planningResourcesMobilityManagementComponent)
     .config(($stateProvider) => {
     	'ngInject';

     	$stateProvider
		.state('ProgramServiceAreas', {
			url: '/planning-resources/data-mapping-tool/mobility-management',
			component: 'planningResourcesMobilityManagement',
			breadcrumbName: 'Mobility Management Program Service Areas',
			parentState: 'DataMappingTool',
               resolve: {
                    details(MobilityManagementMapService) {
                         'ngInject';

                         return MobilityManagementMapService.getMobilitymanagementMapData();
                    }
               }
		});
     })
     .service('MobilityManagementMapService', MobilityManagementMapService)
     .name;


// WEBPACK FOOTER //
// ./src/app/components/planning-resources-mobility-management/planning-resources-mobility-management.module.js